export const initHJ = () =>
  // @ts-ignore
  (window.hj =
    // @ts-ignore
    window.hj ||
    // eslint-disable-next-line prefer-arrow-callback
    function() {
      // @ts-ignore
      const temp = (hj.q = hj.q || [])
      temp.push(arguments)
    })
